"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendAnswerShownQuestion = exports.showQuestionsErrors = exports.endVideoQuestion = exports.drawImageQuestionClickmap = exports.clickImageQuestionClickmap = exports.clickNoOpinionAnswerQuestion = exports.clickNoAnswerQuestion = exports.changeOtherWithTextQuestion = exports.clickOtherWithTextQuestion = exports.clickOtherQuestion = exports.clickTableOptionQuestion = exports.clickOptionQuestion = exports.changeQuestionText = exports.blurQuestionText = void 0;
const blurQuestionText = (questionIndex, text, options) => {
    return Object.assign({ type: 'QUESTION_BLUR_TEXT', questionIndex,
        text }, options);
};
exports.blurQuestionText = blurQuestionText;
const changeQuestionText = (questionIndex, text, options) => {
    return Object.assign({ type: 'QUESTION_CHANGE_TEXT', questionIndex,
        text }, options);
};
exports.changeQuestionText = changeQuestionText;
const clickOptionQuestion = (questionIndex, optionIndex) => {
    return {
        type: 'QUESTION_CLICK_OPTION',
        value: optionIndex,
        questionIndex
    };
};
exports.clickOptionQuestion = clickOptionQuestion;
const clickTableOptionQuestion = (questionIndex, boundQIndex, optionIndex) => {
    return {
        type: 'QUESTION_TABLE_CLICK_OPTION',
        value: {
            optionIndex,
            boundQIndex
        },
        questionIndex
    };
};
exports.clickTableOptionQuestion = clickTableOptionQuestion;
const clickOtherQuestion = (questionIndex) => {
    return {
        type: 'QUESTION_CLICK_OTHER',
        questionIndex
    };
};
exports.clickOtherQuestion = clickOtherQuestion;
const clickOtherWithTextQuestion = (questionIndex) => {
    return {
        type: 'QUESTION_CLICK_OTHER_WITH_TEXT',
        questionIndex
    };
};
exports.clickOtherWithTextQuestion = clickOtherWithTextQuestion;
const changeOtherWithTextQuestion = (questionIndex, value, options) => {
    return Object.assign({ type: 'QUESTION_CHANGE_OTHER_WITH_TEXT', questionIndex,
        value }, options);
};
exports.changeOtherWithTextQuestion = changeOtherWithTextQuestion;
const clickNoAnswerQuestion = (questionIndex) => {
    return {
        type: 'QUESTION_CLICK_NO_ANSWER',
        questionIndex
    };
};
exports.clickNoAnswerQuestion = clickNoAnswerQuestion;
const clickNoOpinionAnswerQuestion = (questionIndex) => {
    return {
        type: 'QUESTION_CLICK_NO_OPINION_ANSWER',
        questionIndex
    };
};
exports.clickNoOpinionAnswerQuestion = clickNoOpinionAnswerQuestion;
const clickImageQuestionClickmap = (questionIndex, event) => {
    return {
        type: 'QUESTION_CLICKMAP_IMAGE_CLICK',
        questionIndex,
        value: event
    };
};
exports.clickImageQuestionClickmap = clickImageQuestionClickmap;
const drawImageQuestionClickmap = (questionIndex, event) => {
    return {
        type: 'QUESTION_CLICKMAP_IMAGE_DRAW',
        questionIndex,
        value: event
    };
};
exports.drawImageQuestionClickmap = drawImageQuestionClickmap;
const endVideoQuestion = (questionIndex, event) => {
    return {
        type: 'QUESTION_VIDEO_END',
        questionIndex,
        value: event
    };
};
exports.endVideoQuestion = endVideoQuestion;
const showQuestionsErrors = questionsIndexes => {
    return {
        type: 'QUESTIONS_SHOW_ERRORS',
        questionsIndexes
    };
};
exports.showQuestionsErrors = showQuestionsErrors;
const sendAnswerShownQuestion = (questionIndex) => {
    return {
        type: 'SEND_ANSWER_SHOWN_QUESTION',
        questionIndex
    };
};
exports.sendAnswerShownQuestion = sendAnswerShownQuestion;
